<template>
	<v-sheet rounded class="mb-4">
		<v-card color="#125B92" elevation="0" class="rounded-b-0">
			<v-card-title class="align-center">
				<h3 class="white--text">Manage Reports</h3>
				<v-spacer />
			</v-card-title>
			<v-divider />
			<v-data-table
				:headers="tableHeaders"
				:items="reportTypes"
				:items-per-page="30"
				hide-default-footer
				class="table-stripped">
				<template #item.default_cost="{ item }">
					<span class="font-mono">{{ item.default_cost | money }}</span>
				</template>
				<template #item.invoice_code="{ item }">
					<v-chip v-if="item.invoice_code" label small>{{ item.invoice_code }}</v-chip>
					<em v-else class="grey--text">None</em>
				</template>
				<template #item.is_active="{ item }">
					<v-icon v-if="item.is_active" color="success">mdi-check-circle</v-icon>
					<v-icon v-else color="grey lighten-2">mdi-check-circle</v-icon>
				</template>
				<template #item.actions="{ item }">
					<v-btn :elevation="0" color="primary" icon @click="editReport(item)">
						<v-icon color="secondary">mdi-pencil</v-icon>
					</v-btn>
				</template>
			</v-data-table>
		</v-card>

		<v-dialog v-model="settingsDialog" transition="scroll-x-reverse-transition" max-width="600px">
			<template #default>
				<v-form @submit.prevent="handleForm">
					<v-card v-if="editing">
						<v-card-title>
							<div>Editing {{ editing.report_type }}</div>
							<v-icon right class="ml-auto theme--dark" @click="settingsDialog = false">mdi-close</v-icon>
						</v-card-title>
						<v-divider class="mb-5" />
						<v-card-text>
							<v-row>
								<v-col>
									<v-text-field
										v-model="form.report_type"
										label="Report Type"
										name="report_type"
										:hide-details="! hasErrors(form, 'report_type')"
										:error="hasErrors(form, 'report_type')"
										:error-messages="errorMsg(form, 'report_type')"
										outlined
										autofocus
										required
										disabled />
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
										v-model="form.report_description"
										label="Report Description"
										name="report_description"
										:hide-details="! hasErrors(form, 'report_description')"
										:error="hasErrors(form, 'report_description')"
										:error-messages="errorMsg(form, 'report_description')"
										outlined
										required />
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
										v-model="form.default_cost"
										name="default_cost"
										label="Default Cost"
										type="number"
										prepend-inner-icon="mdi-currency-usd"
										:error="hasErrors(form, 'default_cost')"
										:hide-details="! hasErrors(form, 'default_cost')"
										:error-messages="errorMsg(form, 'default_cost')"
										outlined />
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
										v-model="form.invoice_code"
										label="Invoice Code"
										name="invoice_code"
										:hide-details="! hasErrors(form, 'invoice_code')"
										:error="hasErrors(form, 'invoice_code')"
										:error-messages="errorMsg(form, 'invoice_code')"
										outlined
										required />
								</v-col>
								<v-col>
									<v-text-field
										v-model="form.invoice_line_item"
										label="Invoice Line Item"
										name="invoice_line_item"
										:hide-details="! hasErrors(form, 'invoice_line_item')"
										:error="hasErrors(form, 'invoice_line_item')"
										:error-messages="errorMsg(form, 'invoice_line_item')"
										outlined
										required />
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-text-field
										v-model="form.template_file"
										label="Blade Template File"
										name="template_file"
										:hide-details="! hasErrors(form, 'template_file')"
										:error="hasErrors(form, 'template_file')"
										:error-messages="errorMsg(form, 'template_file')"
										outlined
										required
										disabled />
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-card outlined class="mt-2">
										<v-card-text>
											<v-switch
												v-model="form.is_active"
												hint="Inactive report types will not be available to add to projects."
												persistent-hint
												class="mt-0"
												label="Active Report"></v-switch>
										</v-card-text>
									</v-card>
								</v-col>
							</v-row>
						</v-card-text>
						<v-divider />
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								color="warning darken-1"
								text
								:disabled="form.processing"
								@click="settingsDialog = false">
								Cancel
							</v-btn>
							<v-btn large type="submit" color="success" :loading="form.processing">Update Report</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</template>
		</v-dialog>
	</v-sheet>
</template>
<script>

export default {
	props: {
		reportTypes: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			settingsDialog: false,
			editing: {},
			form: this.$inertia.form({
				report_type: null,
				report_description: null,
				default_cost: null,
				invoice_code: null,
				invoice_line_item: null,
				template_file: null,
				is_active: null
			}),
			tableHeaders: [
				{
					text: 'Report Name',
					align: 'start',
					value: 'report_type'
				},
				{
					text: 'Description',
					sortable: false,
					align: 'start',
					value: 'report_description'
				},
				{
					text: 'Default Cost',
					align: 'start',
					value: 'default_cost'
				},
				{
					text: 'Invoice Code',
					align: 'start',
					value: 'invoice_code'
				},
				{
					text: 'Invoice Line Item',
					align: 'start',
					value: 'invoice_line_item'
				},
				{
					text: 'Active',
					align: 'center',
					value: 'is_active'
				},
				{
					text: '',
					align: 'end',
					value: 'actions'
				}
			]
		}
	},
	methods: {
		editReport (report) {
			this.settingsDialog = true
			this.editing = report

			for (const reportKey in report) {
				if (!report.hasOwnProperty(reportKey)) continue

				if (this.form.hasOwnProperty(reportKey)) {
					this.form[reportKey] = report[reportKey]
				}
			}
		},

		handleForm () {
			this.form.put(this.route('reporttypes.update', this.editing), {
				onSuccess: () => {
					this.settingsDialog = false
					this.editing = {}
				}
			})
		}
	}
}
</script>
